import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import {array, bool, func, object} from 'prop-types';
import React from 'react';
import EmptyMessage from '../common/EmptyMessage.jsx';
import ProductCard from './ProductCard.jsx';

const InProgressTabContent = ({
  product,
  features,
  loading,
  selectedFeatureRefs,
  setSelectedFeatureRefs,
  setZoomedFeature,
  onReserve,
  collection,
}) => {
  if (!product) {
    return (
      <EmptyMessage
        icon={<Inventory2OutlinedIcon />}
        title="No products selected"
        description="Please select a data product to start quota reservation"
        sx={{
          height: '100%',
        }}
      />
    );
  }

  return (
    <ProductCard
      product={product}
      features={features}
      loading={loading}
      onZoomToFeature={feature => {
        setZoomedFeature(feature);
      }}
      selectedFeatureRefs={selectedFeatureRefs}
      setSelectedFeatureRefs={setSelectedFeatureRefs}
      onReserve={onReserve}
      collection={collection}
    />
  );
};

InProgressTabContent.propTypes = {
  product: object,
  features: array,
  loading: bool,
  selectedFeatureRefs: array,
  setSelectedFeatureRefs: func,
  setZoomedFeature: func,
  onReserve: func,
  collection: object,
};

export default InProgressTabContent;
